import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAppDispatch from '@sportson/core-web/hooks/useAppDispatch';
import { useAppSelector } from '@sportson/core-web/hooks/useAppSelector';
import GetStoresOnhandByPartNo from '@sportson/core-web/libs/GrebbCommerceAPI/Products/GetStoresOnhandByPartNo';
import { Store } from 'assets/media/icons/Store';
import Text from 'components/Text';
import styled from 'libs/styled';

const Div = styled('div')``;
const MessageWrapper = styled(Text)`
    color: var(--color-neutrals-500);
`;
const Span = styled('span')``;

const StoreMessage = ({ product, inStockStore }) => {
    const { t } = useTranslation();
    const selectedStoreCode = useAppSelector(({ ecommerce }) => ecommerce.stores.selected?.storeId);
    const [stores, setStores] = useState<any[]>([]);
    const selectedStore = stores.find((store) => parseInt(store.id) === selectedStoreCode);
    const [storeName, setStoreName] = useState<string | null>(null);

    const getStores = async () => {
        try {
            const response = await GetStoresOnhandByPartNo(product.partNo);
            // response.data[0].items is fallback for old API-data. May be removed later when new api-response is live.
            const stores = response.data[0].items || response.data;
            setStores(stores);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getStores();
    }, [product?.partNo]);

    useEffect(() => {
        if (stores.length > 0) {
            const storeNames = stores
                .filter((store) => store.on_hand_value > 0)
                .map((store) => store.name)
                .join(', ');
            setStoreName(storeNames);
        }
    }, [stores]);

    return (
        <Div display="flex" gap="12px">
            {!selectedStore && (
                <Div display="flex" gap="6px">
                    <MessageWrapper typography="UI/12_100_0_450">
                        <Store />
                        {/* TODO */}
                        <Span paddingLeft="2px">{t('store_message.only_available_in_store', { storeName })}</Span>
                    </MessageWrapper>
                </Div>
            )}
            {!!selectedStore && !inStockStore && (
                <Div display="flex" gap="6px">
                    <MessageWrapper typography="UI/12_100_0_450">
                        <Store />
                        <Span paddingLeft="2px">{t('store_message.not_available_in_store')}</Span>
                    </MessageWrapper>
                </Div>
            )}
        </Div>
    );
};

export default StoreMessage;
